import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormResponseWithDetails } from '../../../services/apiSLTP/qhse/forms/formResponses';
import { FormSectionWithQuestions } from '../../../services/apiSLTP/qhse/forms/formSections';
import { capitalizeFirstLetter } from '../../../utils/capitalize';
import QuestionResponseItem from './QuestionResponseItem';

interface SectionResponseItemProps {
    section: FormSectionWithQuestions;
    sectionIndex: number;
    formColor: string;
    response: FormResponseWithDetails;
}

const SectionResponseItem: React.FC<SectionResponseItemProps> = ({ section, sectionIndex, formColor, response }) => {
    const { t } = useTranslation();

    return (
        <Card sx={{ width: '100%', borderRadius: 0 }}>
            <CardHeader
                sx={{ bgcolor: 'action.selected' }}
                title={<Typography variant="subtitle1">{`${capitalizeFirstLetter(t('section'))} ${sectionIndex + 1}`}</Typography>}
            />
            <CardContent
                sx={{
                    p: 1,
                    gap: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography variant="h5" sx={{ mb: 1 }}>
                    {section.title}
                </Typography>

                {section.questions.map((question, qIndex) => (
                    <QuestionResponseItem
                        key={question._id}
                        question={question}
                        answer={response.answers.find((a) => a.questionId === question._id)}
                        number={qIndex + 1}
                    />
                ))}
            </CardContent>
        </Card>
    );
};

export default SectionResponseItem;
